// src/app/modules/ThreatAlerts/database/column-formatters/ActionsColumnFormatter.jsx
import React from "react";
import { CheckCircle, XCircle } from 'lucide-react';

export function ActionsColumnFormatter(cellContent, row, rowIndex, { onAcknowledge, onResolve }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 6 }}>
      {row.status === 'active' && (
        <>
          <button
            className="sety-btn sety-btn-ghost"
            style={{ padding: '6px 10px' }}
            onClick={() => onAcknowledge(row)}
            title="Acknowledge"
          >
            <CheckCircle size={15} />
          </button>
          <button
            className="sety-btn sety-btn-ghost"
            style={{ padding: '6px 10px' }}
            onClick={() => onResolve(row)}
            title="Resolve"
          >
            <XCircle size={15} />
          </button>
        </>
      )}
      {row.status === 'acknowledged' && (
        <button
          className="sety-btn sety-btn-ghost"
          style={{ padding: '6px 10px' }}
          onClick={() => onResolve(row)}
          title="Resolve"
        >
          <XCircle size={15} />
        </button>
      )}
      {(row.status === 'resolved' || row.status === 'false_positive') && (
        <span className="sety-tbl-sub">—</span>
      )}
    </div>
  );
}
